<template>
   <div class="container-fluid appoint-page">

      <div class="row">

         <!-- Left Column -->
         <div class="col-md-2">
            <div v-if="loading"></div>
            <div v-else id="bar-move" class="grow-bar">
               <!-- INFO -->
               <div class="row info-box">
                  <div class="col-md-12">
                     <div class="ml-purple marb-12">
                        <span>Invited by Agent Number:</span><span v-if="isVBInvitation"> VB Contracting</span><br />
                        <span v-if="!isVBInvitation">
                           <span>{{recruiter.agentNumber}}</span>
                           <br />
                           <span>{{recruiter.phoneNumber|phone}}</span>
                        </span>
                     </div>
                     <div class="ml-corp marb-12" v-if="a.appointment.multiLinkId==null && !isVBInvitation">
                        Level {{levelNo}} - <span class="ml-black">{{levelName}}</span> for<br />
                        {{recruiter.name}}
                     </div>
                     <div v-if="(a.appointment.multiLinkId != null && !isVBInvitation)" class="ml-corp marb-12">
                        <strong>Multiple Appointments</strong><br />
                        for {{recruiter.name}}<br />
                        <div v-for="(itm, indx) in multiAppts" :key="indx">
                           <i class="fas fa-user-edit"></i>
                           {{itm.carrier}} - Level {{itm.levelNo}} - <span class="ml-black">{{itm.levelName}}</span>
                        </div>
                     </div>
                     <div class="ml-purple marb-12">
                        Appointment Type:<br />
                        {{a.appointment.appointmentTypeDesc}}
                        <a href="#"
                           class="fas fa-pencil-alt ml-corp pointer action-link"
                           v-if="changeApptTypeIdList.includes(a.appointment.appointmentTypeId) && this.a.appointment.appointmentStatusCode == 'APWF_STATUS_INCOMPLETE'"
                           v-tooltip:right="'Edit Appointment Type'"
                           @click.prevent="changeApptType" />
                     </div>
                  </div>
               </div>

               <!-- SECTION MENU -->
               <div class="row">
                  <div class="col-md-12">
                     <ul class="plinks">
                        <li>
                           <a v-on:click="goToSection('PERSONAL', false)">
                              <i class="fi-interface-user"></i>
                              Personal Information
                              <i class="fas fa-check p-chk" v-if="sectionStatus.personal"></i>
                           </a>
                        </li>
                        <li>
                           <a v-on:click="goToSection('COMMS', false)">
                              <i class="fi-ecommerce-dollar-symbol-1"></i>
                              Commissions
                              <i class="fas fa-check p-chk" v-if="sectionStatus.commissions"></i>
                           </a>
                        </li>
                        <li v-if="showStateFee">
                           <a v-on:click="goToSection('FEES', false)">
                              <i class="fi-ecommerce-coin"></i>
                              States &amp; Fees
                              <i class="fas fa-check p-chk" v-if="sectionStatus.fees"></i>
                           </a>
                        </li>
                        <li>
                           <a v-on:click="goToSection('AGREEMENTS', false)">
                              <i class="fi-ecommerce-telephone"></i>
                              Policies &amp; Agreements
                              <i class="fas fa-check p-chk" v-if="sectionStatus.agreements"></i>
                           </a>
                        </li>
                        <li>
                           <a v-on:click="goToSection('DOCS', false)">
                              <i class="fi-ecommerce-invoice"></i>
                              Supporting Documents
                              <i class="fas fa-check p-chk" v-if="sectionStatus.docs"></i>
                           </a>
                        </li>
                        <li>
                           <a v-on:click="goToSection('INSTRUCT', false)">
                              <i class="fi-interface-speech-bubble-20"></i>
                              Instructions
                              <i class="fas fa-check p-chk" v-if="sectionStatus.instructions"></i>
                           </a>
                        </li>

                     </ul>
                  </div>
               </div>
            </div>

         </div>

         <!-- Middle Column -->
         <div class="col-md-7 shadow marb-24">
            <div v-if="loading" class="padb-12 marb-12 mart-12 text-center">
               <i class="fas fa-spinner fa-spin ml-orange fa-lg"></i>
            </div>
            <div v-else class="middle-column">
               <form>
                  <h2>Appointment Application</h2>
                  <section-agree v-if="cursection=='AGREEMENTS'"
                                 :v$="v$.a.appointment"
                                 :apptType="a.appointment.appointmentTypeCode"
                                 :apptId="a.appointment.appointmentId"
                                 :sigs="a.appointment.signatures"
                                 @update="onAgreementsUpdate"></section-agree>
                  <section-fees v-if="cursection=='FEES'"
                                :v$="v$.a.appointment"
                                :apptType="a.appointment.appointmentTypeCode"
                                :ccardInfo="a.appointment.ccInfo"
                                :residentState="residentState"
                                :apptId="a.appointment.appointmentId"
                                :sigs="a.appointment.signatures"
                                :states="a.appointment.states"
                                :answers="a.appointment.answers"
                                :isPA="a.appointment.isPA"
                                :isMT="a.appointment.isMT"
                                :allowPuertoRico="hasPuertoRicoStateFee"
                                @update="onStatesUpdate"></section-fees>
                  <section-comms v-if="cursection=='COMMS'"
                                 :v$="v$.a.appointment"
                                 :apptType="a.appointment.appointmentTypeCode"
                                 :apptId="a.appointment.appointmentId"
                                 :sigs="a.appointment.signatures"
                                 :remitType="a.appointment.commissionRemitTypeCode"
                                 :remitAssign="a.appointment.commissionRemitAssign"
                                 :docpath="commStmtPath"
                                 :docpaths="commStmtPaths"
                                 :bankInfo="a.appointment.bankInfo"
                                 @update="onCommsUpdate"></section-comms>
                  <section-docs v-if="cursection=='DOCS'"
                                :willFax="a.appointment.willFax"
                                :apptType="a.appointment.appointmentTypeCode"
                                :appDocs="a.appointment.appUserDocuments"
                                :apptId="a.appointment.appointmentId"
                                :commStmtPath="commStmtPath"
                                :multiAppts="multiAppts"
                                :remitType="a.appointment.commissionRemitTypeCode"
                                @update="onDocsUpdate"></section-docs>
                  <section-personal v-if="cursection=='PERSONAL'"
                                    :initialized="initialized"
                                    :v$="v$.a.appointment"
                                    :v$Home="v$.homeAddress"
                                    :v$Biz="v$.bizAddress"
                                    :personal="a.appointment.personal"
                                    :apptType="a.appointment.appointmentTypeCode"
                                    :apptStatusCode="a.appointment.appointmentStatusCode"
                                    :apptId="a.appointment.appointmentId"
                                    :apptIRSInfo="a.appointment.apptIRSInfo"
                                    :questions="questions"
                                    :comments="a.appointment.qnaComment"
                                    :addresses="a.appointment.addresses"
                                    :sigs="a.appointment.signatures"
                                    :answers="a.appointment.answers"
                                    @update="onPersonalUpdate"></section-personal>
                  <section-instruct v-if="cursection=='INSTRUCT'"></section-instruct>
               </form>

               <div class="text-right mart-24">
                  <button type="button" class="btn ml-btn ml-bk-corp ml-white ml-h-black snc-btn" @click.prevent="saveChanges(true)" v-if="!formIsReadOnly">
                     <i class="fas fa-spinner fa-spin" v-if="btnBusy"></i>
                     <span v-else>
                        SAVE &amp; CONTINUE
                        <i class="fas fa-arrow-right"></i>
                     </span>
                  </button>
               </div>
            </div>
         </div>

         <!-- Right Column -->
         <div class="col-md-3">
            <div v-if="loading"></div>
            <div v-if="!loading" class="gray-card">
               <div class="card-header bg-transparent">
                  <i class="fi-ecommerce-invoice gray-card-icon"></i>
                  <br />
                  <span class="card-label">APPLICATION</span>
               </div>
               <div class="card-body">
                  <div v-if="a.appointment.appointmentStatusCode=='APWF_STATUS_APPROVED'">
                     Agent Number: {{a.appointment.agentNumber}}
                  </div>
                  <div>
                     Application Status: {{a.appointment.appointmentStatusDesc}}
                  </div>

                  <div class="row wf-buttons mart-12 marb-12">
                     <div class="col">
                        <button type="button" class="btn ml-btn ml-bk-black ml-h-orange ml-white"
                                @click.prevent="abortChanges" v-tooltip:right="'Leave without saving and LOSE ANY CHANGES you have made since the last save'">
                           <i class="fas fa-spinner fa-spin" v-if="btnBusy"></i>
                           <span v-else>
                              <i class="fas fa-times"></i>
                              CANCEL
                           </span>
                        </button>
                        <button type="button" class="btn ml-btn ml-bk-corp ml-white ml-h-black" v-if="!formIsReadOnly"
                                @click.prevent="saveChanges(false)" v-tooltip:right="'Save Without Submitting for Approval'">
                           <i class="fas fa-spinner fa-spin" v-if="btnBusy"></i>
                           <span v-else>
                              <i class="fas fa-check"></i>
                              SAVE <span v-if="isDirty">*</span>
                           </span>
                        </button>
                     </div>
                  </div>
                  <div class="row wf-buttons marb-12">
                     <div class="col">
                        <button type="button" class="btn ml-btn ml-bk-white ml-corp ml-h-orange submit-btn" v-if="!formIsReadOnly"
                                v-tooltip:right="'Save and SUBMIT for APPROVAL'" @click.prevent="submitApplication">
                           <i class="fas fa-spinner fa-spin" v-if="btnBusy"></i>
                           <span v-else>
                              <i class="fas fa-check"></i>
                              SUBMIT
                           </span>
                        </button>
                     </div>
                  </div>

               </div>
            </div>

            <div class="gray-card" v-if="!loading && a.appointment.appointmentTypeCode!='APWF_STATUS_APPROVED' && !formIsReadOnly">
               <div class="card-header bg-transparent">
                  <div class="">
                     <canvas id="pieCanvas"></canvas>
                  </div>
                  <span class="card-label">COMPLETION STATUS</span>
               </div>
               <div class="card-body">
                  <div>
                     <div class="text=smaller">
                        You have completed {{ Math.round(pctComplete) }} percent of your appointment application.
                        <span v-if="showDone==true">You can submit this application for approval by clicking the submit button above.</span>
                     </div>
                  </div>

                  <div v-if="v$.$silentErrors.length > 0" class="deficient mart-12">
                     <h3>Application Deficiencies</h3>
                     <div class="deficient-box">
                        <div class="error--row" v-for="(err, index) in v$.$silentErrors" :key="index">
                           <a @click.prevent="gotoError(err)"><i class="fas fa-hand-point-right"></i> {{err.$message}}</a>
                        </div>
                     </div>
                  </div>

               </div>
            </div>
         </div>

      </div>


      <div class="modal fade"
           id="chgApptTypeModal"
           tabindex="-1"
           role="dialog"
           aria-labelledby="chgApptTypeModalLabel"
           aria-hidden="true">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="chgApptTypeModalLabel">
                     <i class="fas fa-user"></i>
                     Change Appointment Type
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div v-if="(isVBInvitation || isVBCustomInvitation)" class="modal-body">
                  <div>
                     <div class="form-group">
                        <label for="newApptTypeId">New Appointment Type:</label>
                        <select class="form-control" placeholder="(Choose New Appointment Type)" v-model="newApptTypeId">
                           <option :value="null" disabled hidden>(Choose New Appointment Type)</option>
                           <option :value="2000" v-if="a.appointment.appointmentTypeId != 2000">VB Individual</option>
                           <option :value="2001" v-if="a.appointment.appointmentTypeId != 2001">VB Corporation</option>
                           <!--<option :value="2002" v-if="a.appointment.appointmentTypeId != 2002">VB Representative</option>-->
                           <option :value="2082" v-if="a.appointment.appointmentTypeId != 2082">VB Individual and Corporation</option>
                        </select>
                     </div>
                     <div v-if="(newApptTypeId == 2001 || newApptTypeId == 2082)" class="form-group">
                        <label for="newApptTypeId">New Type of Business:</label>
                        <select class="form-control" placeholder="(Choose New Appointment Type)" v-model="a.appointment.apptIRSInfo.businessTypeCode">
                           <option :value="null" disabled hidden>(Choose New Appointment Type)</option>
                           <option value='W9BIZ_TYP_CCORP'>C Corporation</option>
                           <option value='W9BIZ_TYP_SCORP'>S Corporation</option>
                           <option value='W9BIZ_TYP_LLC'>Limited Liability Company</option>
                           <option value='W9BIZ_TYP_OTHER'>Other</option>
                        </select>
                     </div>
                  </div>
               </div>
               <div v-else class="modal-body">
                  <div>
                     <div class="form-group">
                        <label for="newApptTypeId">New Appointment Type:</label>
                        <select class="form-control" placeholder="(Choose New Appointment Type)" v-model="newApptTypeId" >
                           <option :value="null" disabled hidden>(Choose New Appointment Type)</option>
                           <option :value="13" v-if="a.appointment.appointmentTypeId != 13">Individual</option>
                           <option :value="14" v-if="a.appointment.appointmentTypeId != 14">Corporation</option>
                        </select>
                     </div>
                     <div v-if="(a.appointment.appointmentTypeId == 13 || a.appointment.appointmentTypeId == 15 ) && newApptTypeId == 14" class="form-group">
                        <label for="newApptTypeId">New Type of Business:</label>
                        <select class="form-control" placeholder="(Choose New Appointment Type)" v-model="a.appointment.apptIRSInfo.businessTypeCode">
                           <option :value="null" disabled hidden>(Choose New Appointment Type)</option>
                           <option value='W9BIZ_TYP_CCORP'>C Corporation</option>
                           <option value='W9BIZ_TYP_SCORP'>S Corporation</option>
                           <option value='W9BIZ_TYP_LLC'>Limited Liability Company</option>
                           <option value='W9BIZ_TYP_OTHER'>Other</option>
                        </select>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn ml-bk-black ml-white ml-h-orange" @click.prevent="cancelChangeApptType">
                     <i class="fas fa-spinner fa-spin" v-if="btnBusy"></i>
                     <span v-else>
                        <i class="fas fa-times"></i>
                        CANCEL
                     </span>
                  </button>
                  <button v-if="showChangeApptTypeOKBtn" type="button" class="btn ml-bk-corp ml-white ml-h-black" @click.prevent="okChangeApptType">
                     <i class="fas fa-spinner fa-spin" v-if="btnBusy"></i>
                     <span v-else>
                        <i class="fas fa-check"></i>
                        OK
                     </span>
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import { mapGetters, mapMutations } from 'vuex';
   import pnlAgreements from "@/components/appt/agreements";
   import pnlFees from "@/components/appt/apptfees";
   import pnlComms from "@/components/appt/commissions";
   import pnlDocs from "@/components/appt/documents";
   import pnlInstruct from "@/components/appt/instructions";
   import pnlPersonal from "@/components/appt/personal";
   import compareSvc from "@/services/CompareService";
   import moment from "moment";
   import FieldVals, { removeCommission, removeStateFees } from "@/services/FieldService";
   import { useVuelidate } from '@vuelidate/core'
   import clone from 'just-clone';
   import $ from 'jquery';

   export default {
      name: 'AppointmentView',
      setup() {
         return { v$: useVuelidate() }
      },
      validations() {
         if (this.fldSvc) {
            if (this.isVBInvitation) this.removeStateFeeFromConfig()
            return this.fldSvc.config
         }
         return {}
      },
      components: {
         "section-agree": pnlAgreements,
         "section-fees": pnlFees,
         "section-comms": pnlComms,
         "section-docs": pnlDocs,
         "section-instruct": pnlInstruct,
         "section-personal": pnlPersonal
      },
      data() {
         return {
            initialized: false,
            formIsReadOnly: false,
            showDone: false,
            showAddRow: false,
            btnBusy: false,
            fldSvc: null,
            cursection: 'PERSONAL', // AGREEMENTS, FEES, COMMS, DOCS, INSTRUCT, PERSONAL
            loading: true,
            pctComplete: 0.0,
            pieCanvas: null,
            pieCtx: null,
            savedAppointment: {},
            cmp: new compareSvc(),
            // true when the fees child reports a selected-but-unconfirmed state
            feesPending: false,
            windowHeight: 0,
            windowWidth: 0,
            TIMEOUT: 20,
            userId: this.$store.getters.appUser.userId,
            questions: [],
            newApptTypeId: 0,
            changeApptTypeIdList: [2000, 2001, 2002, 2082, 13, 14],
            showChangeApptTypeOKBtn: true,
            multiAppts: [],
            dirty: { //docs never set dirty to true sincee they're saved immediately
               personal: false,
               commissions: false,
               fees: false,
               agreements: false,
            },
            sectionStatus: {
               instructions: false,
               personal: false,
               commissions: false,
               fees: false,
               docs: false,
               agreements: false
            },
            deficiencies: [],
            recruiter: {
               name: '',
               address1: '',
               address2: '',
               city: '',
               stateCode: '',
               zipCode: '',
               phoneNumber: '7135551212',
               emailAddress: 'test@test.com',
               agentNumber: '',
               companyNumber: '',
               blockNumber: ''
            },
            levelNo: 0,
            levelName: '',
            commStmtPath: null,
            commStmtPaths: null,
            businessTypes: [],
            appUserDocuments: [],
            a: {
               appointment: {
                  appointmentId: 0,
                  appointmentTypeCode: '',
                  appointmentTypeDesc: '',
                  appointmentLinkId: '',
                  appointmentLink: '',
                  mgaCode: '',
                  appointmentStatusCode: '',
                  appointmentStatusDesc: '',
                  personId: '',
                  agentId: '',
                  agentNumber: '',
                  willFax: false,

                  personal: {
                     lastName: '',
                     firstName: '',
                     middleName: '',
                     ssn: '',
                     birthDate: "2021-07-15T15:33:25.563Z",
                     emailAddress: '',
                     driverLicenseNumber: '',
                     nationalProducerNumber: '',
                     residentStateInsuranceLicenseNumber: '',
                     cellNumber: '',
                     phoneNumber: '',
                     faxNumber: '',
                     businessTypeCode: '',
                     businessName: '',
                     businessCellNumber: '',
                     businessPhone: '',
                     businessFaxNumber: '',
                     businessTaxID: '',
                     sendCorrespondenceToCode: ''
                  },
                  apptIRSInfo: {
                     businessName: '',
                     businessTypeCode: '',
                     businessTypeId: '',
                     businessTypeOther: '',
                     employerIdNumber: '',
                     name:'',
                  },
                  uploadedDt: '',
                  extraWritingNumRequested: false,

                  addresses: [],
                  states: [],
                  answers: [],
                  appUserDocuments: [],
                  residenceAddress: {},
                  businessAddress: {},
                  bankInfo: {
                     appointmentBankInfoId: 0,
                     appointmentId: 0,
                     bankInfoId: 0,
                     bankInfoTypeId: 0,
                     bankName: '',
                     accountTypeId: 0,
                     accountNumber: '',
                     accountNumberLast4: '',
                     routingNumber: '',
                     accountName: '',
                     bankInfoTypeCode: '',
                     accountTypeCode: ''
                  },
                  carrierBlocks: [],
                  feeCollection: [],
                  signatures: [],
                  commissionRemitAssign: {
                     commissionRemittanceAssignmentId: 0,
                     appointmentId: 0,
                     agentAgencyName: '',
                     address1: '',
                     address2: '',
                     city: '',
                     stateCode: '',
                     zip: '',
                     ssnTaxID: '',
                     createDt: '',
                     createdById: '',
                     updateDt: '',
                     updatedById: ''
                  },
                  ccInfo: {
                     creditCardTypeCode: '',
                     cardNumber: '',
                     expirationMonth: '',
                     expirationYear: '',
                     cvcNumber: '',
                     nameonCard: '',
                     billingAddress: '',
                     city: '',
                     stateCode: '',
                     zip: ''
                  }
               }
            },
            homeAddress: {},
            bizAddress: {}
         }
      },

      computed: {
         ...mapGetters(["isVBInvitation", "isVBCustomInvitation"]),
         isDirty: function () {
            return (this.dirty.agreements || this.dirty.fees || this.dirty.commissions || this.dirty.docs || this.dirty.personal)
         },
         residentState: function () {
            if (this.a && this.a.addresses && this.a.addresses.length > 0) {
               this.a.addresses.forEach((item, index) => {
                  if (item.addressTypeCode == 'ADRTYP_HOME')
                     return item.stateCode
               })
            }
            return ''
         },
         showStateFee: function () {
            return this.showType(['C', 'B', 'I', 'R'], this.a.appointment.appointmentTypeCode);
         },
         hasPuertoRicoStateFee: function () {

            if (this.a && this.a.appointment && Array.isArray(this.a.appointment.states)) {
               return this.a.appointment.states.some(s => {
                  const code = (s.stateCode || '').toString().toUpperCase()
                  const name = (s.stateName || '').toString().toLowerCase().trim()
                  return code === 'PR' || name === 'puerto rico'
               })
            }
            return false
         }
      },
      async mounted() {
         this.$parent.loadingStart()
         try {
            this.initialized = true
            this.loading = true
            window.addEventListener("scroll", this.handleMenuScroll);
            if (this.$route.hash) {
               setTimeout(() => this.scrollTo(this.$route.hash), this.TIMEOUT);
            }
            await this.initialize()
         } finally {
            this.loading = false
            await this.$nextTick()
            this.initPie()
            this.$parent.loadingEnd()
         }
      },
      beforeDestroy() {
         window.removeEventListener("scroll", this.handleMenuScroll);
      },
      methods: {
         ...mapMutations(["updateEmailTemplateTypeId", "setIsVBInvitationFromApptType"]),
         async initialize() {
            await this.loadQuestions()
            if (this.$route.params.init) { //create a brand new appt from invitation
               let failed = await this.initNewAppointment(this.$route.params.init)
               if (failed) return
               await this.createAppt()
            } else if (this.$route.params.multiPaper != undefined) {
               await this.initMultiPaper()
            } else if (this.$route.params.email != undefined) {
               await this.createPaperAppointment()
                  .then(async r => {
                     if (r != undefined && r != null) {
                        if (r == 0) {
                           this.$swal(
                              "System Error",
                              "Oops! Some unforseen system error occurred while trying to Create a New application. Please try again later. If this problem persists please contact support.",
                              "error"
                           )
                           this.$route.push({ name: 'home' })
                        }
                        this.a.appointment.appointmentId = r
                        await this.loadAppointment()
                        await this.loadRecruiter()
                     } else {
                        this.$swal(
                           "System Error",
                           "Oops! Some unforseen system error occurred while trying to Create a New application. Please try again later. If this problem persists please contact support.",
                           "error"
                        )
                        this.$route.push({ name: 'home' })
                     }
                  })
                  .catch(err => {
                     this.$swal(
                        "System Error",
                        "Oops! Some unforseen system error occurred while trying to fetch the application. Please try again later. If this problem persists please contact support.",
                        "error"
                     );
                     this.$router.push({ name: 'home' })
                  })

            } else if (this.$route.params.id) { // open existing application
               this.a.appointment.appointmentId = this.$route.params.id
               await this.loadAppointment()
               await this.loadRecruiter()
            }

            this.setIsVBInvitationFromApptType(this.a.appointment.appointmentTypeCode)
            this.v$.$reset
            this.fldSvc = new FieldVals(this.a.appointment)
            if (this.isVBInvitation) {
               this.fldSvb = removeStateFees(this.fldSvc);
            }
            if (this.isVBCustomInvitation) {
               this.fldSvb = removeCommission(this.fldSvc);
            }
            if (this.a.appointment.appUserDocuments == null) {
               this.a.appointment.appUserDocuments = []
            }

            this.savedAppointment = clone(this.a.appointment)
            this.dirty.agreements = false
            this.dirty.fees = false
            this.dirty.commissions = false
            this.dirty.docs = false
            this.dirty.personal = false
         },
         removeStateFeeFromConfig() {
            const cfg = this.fldSvc.config;
            if (!cfg.a || !cfg.a.appointment || cfg.a.appointment.stateFeeQuestion !== undefined) {

               console.log(`stateFeeQuestion = ${JSON.stringify(cfg.a.appointment.stateFeeQuestion)}`)
               if (typeof this.$delete === "function") {
                  // removes property reactively for observed objects
                  this.$delete(cfg.a.appointment, "stateFeeQuestion");
               } else {
                  // fallback
                  delete cfg.a.appointment.stateFeeQuestion;
               }
            }
         },

         async okChangeApptType() {
            if (this.newApptTypeId == 0 || this.newApptTypeId == null) {
               this.$swal(
                  "Change to Which Appointment Type?",
                  "Please choose a Appointment Type from the dropdown before clicking OK.",
                  "question"
               );
               return
            }

            if ((this.newApptTypeId == 2001 || this.newApptTypeId == 2082) && (
               this.a.appointment.apptIRSInfo.businessTypeCode != 'W9BIZ_TYP_CCORP' &&
               this.a.appointment.apptIRSInfo.businessTypeCode != 'W9BIZ_TYP_SCORP' &&
               this.a.appointment.apptIRSInfo.businessTypeCode != 'W9BIZ_TYP_LLC' &&
               this.a.appointment.apptIRSInfo.businessTypeCode != 'W9BIZ_TYP_OTHER')) {
               this.$swal(
                  "Business Type is not Valid",
                  "Please select one of choices from the New Business Type dopdown before clicking OK.",
                  "error"
               );
               return
            }

            if (this.newApptTypeId == 2000) {
               this.a.appointment.apptIRSInfo.businessTypeCode = 'W9BIZ_TYP_IND'
            }

            await this.$swal({
               title: "Changing Appointment Type?",
               html: "Are you sure you want to change the Appointment Type of this appointment application?",
               icon: "warning",
               heightAuto: false,
               showDenyButton: true,
               showCancelButton: false,
               confirmButtonText: "Yes",
               confirmButtonColor: "#D14529",
               denyButtonText: "No",
               denyButtonColor: '#2778C4',
               reverseButtons: true,
               focusConfirm: false,
            }).then(async result => {
               if (await result.isConfirmed) {
                  await this.executeApptTypeChange()
                  $('#chgApptTypeModal').modal('hide')
               }
            })
         },

         async executeApptTypeChange() {

            let scheduleChangeMsg = "The Appointment Type and Schedule(s) of this appointment were successfully changed."
            let successMsg = "The Appointment Type of this appointment was successfully changed."
            let payload = {
               appointmentId: this.a.appointment.appointmentId,
               oldApptTypeId: this.a.appointment.appointmentTypeId,
               newApptTypeId: this.newApptTypeId,
               newBusinessTypeCode: this.a.appointment.apptIRSInfo.businessTypeCode,
               userId: this.userId.toUpperCase()
            }

            this.btnBusy = true
            await this.$appoint.changeApptType(payload)
               .then(async result => {
                  if (result && result == true) {
                     await this.removeAllUserDocuments();
                     this.$swal(
                        "Success!",
                        successMsg,
                        "success"
                     ).then(async () => {
                        $('#chgApptTypeModal').modal('hide');
                        // Ensure the route contains the appointment id before forcing a reload
                        const newId = String(this.a.appointment.appointmentId || '')
                        const target = { name: "appoint", params: { id: newId } }
  
                        try {
                           // Only call router.replace if the current route differs (prevents NavigationDuplicated)
                           if (this.$route.name !== 'appoint' || String(this.$route.params.id) !== newId) {
                              await this.$router.replace(target)
                              // Reload route so mounted hooks run again
                              this.$router.go()
                           } else {
                              // Same route + id -> do a full browser navigation to the resolved href so params persist
                              const href = this.$router.resolve(target).href
                              window.location.href = href
                           }
                        } catch (err) {
                           // Fallback: full navigation to ensure id is present after refresh
                           const href = this.$router.resolve(target).href
                           window.location.href = href
                        }
                        return
                     })
                  } else {
                     this.$swal(
                        "Oops!",
                        "An error occurred trying to change Appointment Type. Please try again later or contact support if this problem persists.",
                        "error"
                     );
                  }
                  $('#chgApptTypeModal').modal('hide')
               })
            this.btnBusy = false
         },

         async changeApptType() {
            this.newApptTypeId = null
            $('#chgApptTypeModal').modal('show')
         },
         cancelChangeApptType() {
            $('#chgApptTypeModal').modal('hide')
         },

         async removeAllUserDocuments() {
            var result = false
            const userId = this.a.appointment.personId;
            await this.$agent.removeUserDocuments(userId)
               .then(r => {
                  if (r != null && r > 0) {
                     result = true
                  }
               })
            return result
         },
         async createPaperAppointment() {
            let payload = {
               link: this.$route.params.link,
               emailAddress: this.$route.params.email,
               apptTypeCode: this.$route.params.apptTypeCode,
               submitterId: this.$route.params.submitterId,
               isPaperAppointment: true
            }
            return await this.$appoint.createPaperAppointment(payload)
         },
         async loadQuestions() {
            await this.$appoint.getQuestions("QUES_TYP_PERSONAL")
               .then(r => {
                  if (r) {
                     this.questions = r
                  }
               })
         },
         async loadRecruiter() {
            if (this.a.appointment.multiLinkId == null && this.a.appointment.appointmentStatusCode != "APWF_STATUS_APPROVED") {
               return await this.loadRecruiterForNonMultiLink();
            }

            let multiLinkId = 0
            //approved and multilink is null...get the multilink from the parent appointment
            if (this.a.appointment.multiLinkId == null && this.a.appointment.appointmentStatusCode == "APWF_STATUS_APPROVED") {
               await this.$appoint.getParentMultiLinkId(this.a.appointment.appointmentId)
                  .then(r => {
                     if (r) {
                        multiLinkId = r
                     }
                  })
            }
            else if (this.a.appointment.multiLinkId != null) {
               multiLinkId = this.a.appointment.multiLinkId 
            }

            const r = await this.$appoint.getMultiRecruiter(multiLinkId);
            if (!r || !r.agent || !r.agent.agentType) {
               return;
            }

            this.setRecruiter(r);
            this.updateEmailTemplateTypeId(r.corrTemplateTypeId);

            this.multiAppts = r.multiLinks;
            this.commStmtPaths = []
            this.multiAppts.forEach((itm) => {
               this.commStmtPaths.push(itm.documentPath)
            })
         },
         async loadRecruiterForNonMultiLink() {
            const r = await this.$appoint.getRecruiter(this.a.appointment.appointmentLink)
            if (!r || !r.agent || !r.agent.agentType) {
               return;
            }

            this.setRecruiter(r);
            this.updateEmailTemplateTypeId(r.corrTemplateTypeId);

            this.levelNo = r.levelNo
            this.levelName = r.levelName
            this.commStmtPath = r.documentPath
         },
         setRecruiter(r) {
            let recruiterName;
            if (r.agent.agentType == 'C') {
               recruiterName = r.agent.companyName
            } else {
               recruiterName = r.agent.firstName + ' ' + r.agent.lastName
            }
            this.recruiter = {
               name: recruiterName,
               address1: r.agent.address1,
               address2: r.agent.address2,
               city: r.agent.city,
               stateCode: r.agent.state,
               zipCode: r.agent.zip,
               phoneNumber: r.agent.phoneNumber,
               emailAddress: r.agent.emailAddress,
               agentNumber: r.recruiterAgentNumber,
               companyNumber: r.recruiterCompanyNumber,
               blockNumber: r.recruiterBlockNumber
            }
         },
         handleMenuScroll() {
            // Reposition the menus when the user scrolls
            var stShrink = 80;
            var he = document.getElementById("bar-move");
            if (he) {
               if (window.pageYOffset > stShrink) {
                  he.classList.remove("grow-bar");
                  he.classList.add("shrink-bar");
               } else {
                  he.classList.remove("shrink-bar");
                  he.classList.add("grow-bar");
               }
            }
         },
         cleanNumber(vlu) {
            let nuVlu = vlu.replace(/\D/g, '')
            return nuVlu
         },
         initPie() {
            this.pieCanvas = document.getElementById("pieCanvas")
            if (this.pieCanvas) {
               this.pieCanvas.width = 60
               this.pieCanvas.height = 60
               this.pieCtx = this.pieCanvas.getContext("2d")
               this.calcCompletionPct()
            }
         },
         calcCompletionPct() {

            if (!this.v$.$invalid) {
               this.pctComplete = 100;
               this.sectionStatus.personal = true
               this.sectionStatus.commissions = true
               this.sectionStatus.fees = true
               this.sectionStatus.agreements = true
               this.sectionStatus.docs = true
               this.showDone = true
            } else {


               // To get the completion count we are get the total amount of incomplete
               // fields by counting the fields that are invalid
               //
               // We are also setting each section's completion checkmark

               let PERSONAL = 0, COMMS = 0, FEES = 0, AGREEMENTS = 0, DOCS = 0
               this.v$.$silentErrors.forEach((err) => {
                  let key = this.getFieldKey(err)
                  let dest = this.fldSvc.locateField(key)
                  if (dest) {
                     switch (dest.page) {
                        case 'PERSONAL':
                           PERSONAL++
                           break
                        case 'COMMS':
                           COMMS++
                           break
                        case 'FEES':
                           FEES++
                           break
                        case 'AGREEMENTS':
                           AGREEMENTS++
                           break
                        case 'DOCS':
                           DOCS++
                           break
                     }
                  }
               })

               // Count off for individual questions that are not answered
               let reqd = 15
               let answered = 0
               this.questions.forEach(q => {
                  if (q.isTextOnly == false && !this.hasNoAnswer(q.questionId)) {
                     answered++
                  }
               })
               PERSONAL += (reqd - answered)

               let c = this.fldSvc.completion

               if (this.isVBInvitation) {
                  this.pctComplete = 100.0 - ((100.0 / (c.personal + c.comms + c.agrees + c.docs)) * (PERSONAL + COMMS + AGREEMENTS + DOCS))
               }
               else {
                  this.pctComplete = 100.0 - ((100.0 / (c.personal + c.comms + c.fees + c.agrees + c.docs)) * (PERSONAL + COMMS + FEES + AGREEMENTS + DOCS))
               }

               this.sectionStatus.personal = (PERSONAL == 0)
               this.sectionStatus.commissions = (COMMS == 0)
               this.sectionStatus.fees = (FEES == 0)
               this.sectionStatus.agreements = (AGREEMENTS == 0)
               this.sectionStatus.docs = (DOCS == 0)
            }

            this.redrawPie()
         },
         redrawPie() {
            let total_value = 100
            let color = "#00a7a1"
            let startAngle = 0;
            let val = this.pctComplete;
            let sliceAngle = 2 * Math.PI * val / total_value;

            //draw slice
            let ctx = this.pieCtx
            if (ctx) {
               ctx.clearRect(0, 0, this.pieCanvas.width, this.pieCanvas.height);
               ctx.fillStyle = color;
               ctx.beginPath();
               ctx.moveTo(this.pieCanvas.width / 2, this.pieCanvas.width / 2);
               ctx.arc(
                  this.pieCanvas.width / 2,
                  this.pieCanvas.width / 2,
                  Math.min(this.pieCanvas.width / 2, this.pieCanvas.height / 2),
                  startAngle,
                  startAngle + sliceAngle
               );
               ctx.closePath();
               ctx.fill();

               //Outer circle
               ctx.beginPath();
               ctx.moveTo(this.pieCanvas.width / 2, this.pieCanvas.width / 2);
               ctx.arc(
                  this.pieCanvas.width / 2,
                  this.pieCanvas.width / 2,
                  Math.min(this.pieCanvas.width / 2, this.pieCanvas.height / 2) - 1.0,
                  startAngle,
                  2 * Math.PI
               );
               ctx.closePath();
               ctx.strokeStyle = color;
               ctx.lineWidth = 1;
               ctx.stroke();
            }
         },
         async initMultiPaper() {
            let p = this.$route.params
            let payload = {
               link: this.$route.params.link,
               emailAddress: this.$route.params.email,
               apptTypeCode: this.$route.params.apptTypeCode,
               submitterId: this.$route.params.submitterId,
               isPaperAppointment: true,
               multiLinkId: this.$route.params.multiLinkId
            }
            await this.$appoint.createPaperAppointment(payload)
               .then(async r => {
                  if (r != undefined && r != null) {
                     if (r == 0) {
                        this.$swal(
                           "System Error",
                           "Oops! Some unforseen system error occurred while trying to Create a New application. Please try again later. If this problem persists please contact support.",
                           "error"
                        )
                        this.$route.push({ name: 'home' })
                     }
                     this.a.appointment.appointmentId = r
                     await this.loadAppointment()
                     await this.loadRecruiter()
                  } else {
                     this.$swal(
                        "System Error",
                        "Oops! Some unforseen system error occurred while trying to Create a New application. Please try again later. If this problem persists please contact support.",
                        "error"
                     )
                     this.$route.push({ name: 'home' })
                  }
               })
               .catch(err => {
                  this.$swal(
                     "System Error",
                     "Oops! Some unforseen system error occurred while trying to fetch the application. Please try again later. If this problem persists please contact support.",
                     "error"
                  );
                  this.$router.push({ name: 'home' })
               })
         },
         async initNewAppointment(i) {
            let usr = this.$store.getters.appUser
            let claims = this.$store.getters.userClaims
            this.recruiter = i.recruiter

            //fix ssn
            const whitespaceRegExp = / /g

            this.a.appointment = {
               appointmentId: 0,
               appointmentLinkId: 0,
               agentId: null,
               uploadedDt: null,
               personId: this.userId.toUpperCase(),
               appointmentTypeCode: i.appointmentTypeCode,
               appointmentLink: i.link,
               personal: {
                  birthDate: null,
                  firstName: claims.given_name,
                  middleName: claims.extension_MiddleName,
                  lastName: claims.family_name,
                  emailAddress: usr.userName,
                  cellNumber: claims.extension_PhoneNumber,
                  //   ssn : claims.extension_TaxID
               },
               stateFeeQuestion: {
                  answer: null,
                  isPA: false,
                  isMT: false,
               },
            }

            if (i.appointmentTypeCode == 'APPTTYP_BOTH') {
               i.appointmentTypeCode = 'APPTTYP_CORP'
               if (this.isVBInvitation) i.appointmentTypeCode = 'APPTTYP_VB_CORP';
               this.a.appointment.extraWritingNumRequested = true
            }

            if (i.multiLinks) {
               this.a.appointment.multiLinkId = i.multiLinkId
               this.multiAppts = i.multiLinks
               this.commStmtPaths = []
               this.multiAppts.forEach((itm) => {
                  this.commStmtPaths.push(itm.documentPath)
               })
            } else {
               this.levelNo = i.levelNo
               this.levelName = i.levelName
               this.commStmtPath = i.documentPath
            }

         },
         async loadAppointment() {
            await this.$appoint.getAppointment(this.a.appointment.appointmentId)
               .then(r => {
                  if (r.personal.birthDate != null) {
                     r.personal.birthDate = moment(r.personal.birthDate).format("YYYY-MM-DD")
                  }
                  this.a.appointment = r

                  // Apps that are submitted for approval, approved, or abandoned are NOT editable
                  if (this.a.appointment.appointmentStatusCode != "APWF_STATUS_INCOMPLETE" && this.a.appointment.appointmentStatusCode != "APWF_STATUS_INVITED") {
                     this.formIsReadOnly = true;
                  }
                  if (this.a.appointment.appointmentStatusCode == "APWF_STATUS_NEWCONTRACT") {
                     this.a.appointment.appointmentStatusDesc = "Awaiting Approval"
                  }

                  this.homeAddress = this.addressByType('ADRTYP_HOME')
                  this.bizAddress = this.addressByType('ADRTYP_BUSINESS')
               })
               .catch(err => {
                  this.$swal(
                     "System Error",
                     "Oops! Some unforseen system error occurred while trying to fetch the application. Please try again later. If this problem persists please contact support.",
                     "error"
                  );
                  this.$router.push({ name: 'home' })
               })
         },
         addressByType(typ) {
            if (this.a.appointment === undefined) return null
            let itm = null
            this.a.appointment.addresses.forEach((element, indx) => {
               if (element.addressTypeCode == typ) {
                  itm = element
               }
            })
            return itm
         },
         hasNoAnswer(questionId) {
            if (this.a == undefined ||
               this.a.appointment == undefined ||
               this.a.appointment.answers == undefined) {
               return false
            }
            let answer = this.a.appointment.answers.find(a => a.questionId == questionId)
            if (answer == undefined || (answer !== undefined && answer.answerBoolean == null)) return true
            return false
         },
         errorText(err) {
            if (err.$error) {
               return err.$errors.map(itm => itm.$message).join(',')
            }
            return ''
         },
         async deleteApp() {

         },
         abortChanges() {
            this.btnBusy = true

            if (this.isDirty) {
               this.$swal({
                  title: "Are you sure?",
                  text: `You have made changes that will be lost and cannot be recovered.`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: 'YES',
                  cancelButtonText: 'NO',
                  cancelButtonColor: '#000000',
                  confirmButtonColor: '#00a7a1'
               })
                  .then((result) => {
                     this.btnBusy = false
                     if (result.isConfirmed) {
                        this.$router.push({ name: 'home' })
                     }
                  })

            } else {
               this.btnBusy = false
               this.$router.push({ name: 'home' })
            }
         },
         cleanEmptyStates() {
            // Remove any empty / incomplete state items to avoid API errors.
            if (!this.a || !this.a.appointment) return;
            const arr = this.a.appointment.states;
            if (!Array.isArray(arr)) return;
            this.a.appointment.states = arr.filter(item => {
               if (!item) return false;
               // keep if stateId is present OR at least a meaningful name/code exists
               if (item.stateId !== null && item.stateId !== undefined && String(item.stateId).trim() !== '') return true;
               if (item.stateCode && String(item.stateCode).trim() !== '') return true;
               if (item.stateName && String(item.stateName).trim() !== '') return true;
               return false;
            });
         },
         async saveChanges(nxt) {
            // Block only when the fees add-row contains a pending selection (actual chosen state not confirmed)
            if (this.cursection === 'FEES' && this.feesPending === true) {
               this.$swal(
                  "Add the State?",
                  "You've started to add a state but haven't confirmed or rejected your selection. Before moving on you must click either the Checkmark the X on the new state row.",
                  "error"
               );
               return
            }
            this.btnBusy = true

            if (this.a.appointment.personal.birthDate == "") {
               this.a.appointment.personal.birthDate = null
            }

            // Defensive: remove any empty state rows before saving to backend
            this.cleanEmptyStates();

            await this.$appoint.save(this.a.appointment)
               .then((r) => {
                  this.btnBusy = false
                  if (!r || r == false) {
                     this.$swal(
                        "The Save Failed",
                        "Oops. We apologize for a system error that caused this to fail. Please try again. If you think you've reached this impass in error, please contact support.",
                        "error"
                     );
                     return;
                  }
                  this.$swal(
                     "Successfully Saved!",
                     "Your application changes have been saved but NOT submitted for approval.",
                     "success"
                  ).then(() => {

                     if (nxt) { // goto next section
                        let sec = ''
                        switch (this.cursection) {
                           case "PERSONAL":
                              sec = 'COMMS'
                              break
                           case "COMMS":
                              if (this.isVBInvitation) {
                                 sec = 'AGREEMENTS';
                                 break
                              }
                              sec = 'FEES'
                              break
                           case "FEES":
                              sec = 'AGREEMENTS'
                              break
                           case "AGREEMENTS":
                              sec = 'DOCS'
                              break
                           case "DOCS":
                              sec = 'INSTRUCT'
                              break
                           default:
                              sec = 'PERSONAL'
                              break
                        }
                        this.goToSection(sec, false)
                     } else {
                        this.$router.push({ name: 'home' })
                     }
                  });
               })
               .catch((err) => {
                  this.btnBusy = false
                  this.$swal(
                     "Oops!",
                     "The Save has failed due to some System Error. Please try again and if the problem persists, please contact support.",
                     "error"
                  );
               })
         },
         getFieldKey(err) {
            let key = ''
            if (err.$property == 'appUserDocuments' || err.$property == 'signatures' || err.$property == 'bankInfo') {
               key = err.$validator
            } else {
               if (err.$propertyPath.indexOf('homeAddress') > -1 || err.$propertyPath.indexOf('bizAddress') > -1) {
                  key = err.$propertyPath
               } else if (err.$propertyPath.indexOf('commissionRemitAssign') > -1) {
                  key = err.$propertyPath.replace("a.appointment.", "")
               } else {
                  key = err.$property
               }
            }
            return key
         },
         async gotoError(err) {
            let key = this.getFieldKey(err)
            let dest = this.fldSvc.locateField(key)
            if (!dest) {
               return
            }
            this.goToSection(dest.page, true)

            // Wait for screen to finish re-rendering
            await this.$nextTick()

            if (dest.elementName) {
               setTimeout(() => {
                  let ele = document.getElementById(dest.elementName)
                  if (!ele) {
                     return
                  }
                  ele.scrollIntoView();
                  let off = document.querySelector('#header').offsetHeight + 12
                  let scrolledY = window.scrollY;
                  if (scrolledY) {
                     window.scroll(0, scrolledY - off);
                  }
                  ele.focus()
               }, 1000)

            }
         },
         async submitApplication() {
            if (this.cursection === 'FEES' && this.feesPending === true) {
               this.$swal(
                  "Add the State?",
                  "You've started to add a state but haven't confirmed or rejected your selection. Before moving on you must click either the Checkmark the X on the new state row.",
                  "error"
               );
               return
            }
            this.v$.$touch()
            if (this.v$.$invalid) {
               return // do not allow submit
            }

            this.btnBusy = true

            this.a.appointment.appointmentStatusCode = "APWF_STATUS_NEWCONTRACT"
            if (this.a.appointment.personal.birthDate == "") {
               this.a.appointment.personal.birthDate = null
            }

            // Defensive: remove any empty state rows before saving to backend
            this.cleanEmptyStates();

            await this.$appoint.save(this.a.appointment)
               .then((r) => {
                  this.btnBusy = false
                  if (!r || r == false) {
                     this.$swal(
                        "The Submit Failed",
                        "Oops. We apologize for a system error that caused this to fail. Please try again. If you think you've reached this impass in error, please contact support.",
                        "error"
                     );
                     return;
                  }
                  this.$swal(
                     "Successfully Submitted for Approval!",
                     "Your application has been received and submitted for approval.",
                     "success"
                  ).then(() => {
                     this.$router.push({ name: 'home' })
                  });
               })
               .catch((err) => {
                  this.btnBusy = false
                  this.$swal(
                     "Oops!",
                     "The Submit has failed due to some System Error. Please try again and if the problem persists, please contact support.",
                     "error"
                  );
               })
         },
         async createAppt() {
            let payload = {
               appointment: this.a.appointment,
               createdById: this.userId.toUpperCase()
            }
            await this.$appoint.create(payload)
               .then(async (r) => {
                  if (!r) {
                     this.$swal(
                        "System Error",
                        "Oops! Some unforseen system error occurred while trying to create the application. Please try again later. If this problem persists please contact support.",
                        "error"
                     );
                     this.$router.push({ name: 'wizard' })
                  }
                  this.a.appointment.appointmentId = r
                  await this.loadAppointment()
               })
               .catch(err => {
                  this.$swal(
                     "System Error",
                     "Oops! Some unforseen system error occurred while trying to create the application. Please try again later. If this problem persists please contact support.",
                     "error"
                  );
                  this.$router.push({ name: 'wizard' })
               })
         },
         async goToSection(sec, skip) {
            this.cursection = sec;
            if (sec == 'INSTRUCT') {
               this.sectionStatus.instructions = true
            }
            if (!skip) {
               await this.$nextTick()
               setTimeout(() => window.scrollTo(0, 0), 1000)
            }
         },
         showType(tarr, apptType) {
            if (apptType === undefined) return false
            switch (apptType) {
               case 'APPTTYP_WVB':
                  if (tarr.includes("VI")) return true
                  break
               case 'APPTTYP_VB_BOTH':
                  if (tarr.includes("VC")) return true
                  break
               case 'APPTTYP_IND':
                  if (tarr.includes("I")) return true
                  break
               case 'APPTTYP_VB_REP':
                  if (tarr.includes("VR")) return true
                  break
               case 'APPTTYP_REP':
                  if (tarr.includes("R")) return true
                  break
               case 'APPTTYP_CORP':
                  if (tarr.includes("C")) return true
                  break
               case 'APPTTYP_VB_CORP':
                  if (tarr.includes("VC")) return true
                  break
               case 'APPTTYP_BOTH':
                  if (tarr.includes("B")) return true
                  break
               case 'APPTTYP_PRIN':
                  if (tarr.includes("P")) return true
                  break
            }
            return false
         },
         readOnly() {
            if (this.formIsReadOnly)
               return 'readonly'
            else
               return null
         },
         allowApprovedEdit() {
            if (this.a.appointment.appointmentStatusCode == 'APWF_STATUS_APPROVED' ||
               this.a.appointment.appointmentStatusCode == 'APWF_STATUS_NEWCONTRACT' ||
               this.a.appointment.appointmentStatusCode == 'APWF_STATUS_INCOMPLETE') {
               return true
            } else {
               return false
            }
         },
         signatureByType(typ) {
            if (this.a.appointment.signatures === undefined) return null
            let ele = null
            this.a.appointment.signatures.forEach((element, indx) => {
               if (element.signatureTypeCode == typ) {
                  ele = element
               }
            })
            return ele
         },
         PropogateSignature() {
            if (this.a.appointment.signatures === undefined) return
            if (this.$store.getters.signature == '') return
            let sig = this.signatureByType('SIGTYP_QNA')
            if (sig) sig.signatureValue = this.$store.getters.signature
            sig = this.signatureByType('SIGTYP_W9_CERT')
            if (sig) sig.signatureValue = this.$store.getters.signature
            sig = this.signatureByType('SIGTYP_COMSCHED')
            if (sig) sig.signatureValue = this.$store.getters.signature
            sig = this.signatureByType('SIGTYP_ST_FEES')
            if (sig) sig.signatureValue = this.$store.getters.signature
            sig = this.signatureByType('SIGTYP_AGREESIG')
            if (sig) sig.signatureValue = this.$store.getters.signature
            sig = this.signatureByType('SIGTYP_COMSCHED_AGT')
            if (sig) sig.signatureValue = this.$store.getters.agentName
            sig = this.signatureByType('SIGTYP_AGREENAME')
            if (sig) sig.signatureValue = this.$store.getters.agentName
         },

         //Methods to react to data changes
         onStatesUpdate(newData) {
            // keep add-row visibility and pending flag from child
            this.showAddRow = newData.showAddRow
            this.feesPending = !!newData.pendingState

            // Accept the child's authoritative states array so validation sees it
            this.a.appointment.states = Array.isArray(newData.states) ? newData.states : [];

            // other pieces from child
            this.a.appointment.signatures = newData.signatures
            this.a.appointment.ccInfo = newData.ccInfo

            // mark dirty if anything changed vs saved copy
            this.dirty.states = false
            if (!this.cmp.isEqual(this.savedAppointment.signatures, newData.signatures) ||
               !this.cmp.isEqual(this.savedAppointment.states, newData.states) ||
               !this.cmp.isEqual(this.savedAppointment.ccInfo, newData.ccInfo)) {
               this.dirty.states = true
            }
            this.a.appointment.answers = newData.answers
            this.a.appointment.isPA = newData.isPA
            this.a.appointment.isMT = newData.isMT

            // Recalculate completion / validation UI
            this.calcCompletionPct()
         },
         onAgreementsUpdate(newData) {
            this.dirty.agreements = false
            this.a.appointment.signatures = newData.signatures
            if (!this.cmp.isEqual(this.savedAppointment.signatures, newData.signatures)) {
               this.dirty.agreements = true
            }

            this.calcCompletionPct()
         },
         onCommsUpdate(newData) {
            this.dirty.commissions = false

            // banking info
            this.a.appointment.bankInfo = newData.bankInfo

            // remit assign
            this.a.appointment.commissionRemitAssign = newData.remitAssign

            if (this.savedAppointment.commissionRemitTypeCode != newData.remitanceType ||
               !this.cmp.isEqual(this.savedAppointment.signatures, newData.signatures) ||
               !this.cmp.isEqual(this.savedAppointment.bankInfo, this.a.appointment.bankInfo) ||
               !this.cmp.isEqual(this.savedAppointment.commissionRemitAssign, this.a.appointment.commissionRemitAssign)) {
               this.dirty.commissions = true
            }
            this.a.appointment.commissionRemitTypeCode = newData.remitanceType
            this.a.appointment.signatures = newData.signatures

            this.calcCompletionPct()
         },
         async onDocsUpdate(newData) {

            if (typeof newData !== 'object') {
               if (newData == true) {
                  let personId = this.a.appointment.personId
                  await this.$document.getDocuments(personId)
                     .then(r => {
                        if (r) {
                           this.a.appointment.appUserDocuments = r
                        }
                     })

                  this.calcCompletionPct()
               }
            }
            else if (newData.willFax !== undefined && newData.willFax != null) {
               this.a.appointment.willFax = newData.willFax
               this.v$.a.appointment.appUserDocuments.$touch()
               this.calcCompletionPct()
            }
         },
         onPersonalUpdate(newData) {
            this.dirty.personal = false
            if (!this.cmp.isEqual(this.savedAppointment.personal, newData.personal) ||
               !this.cmp.isEqual(this.savedAppointment.addresses, newData.addresses) ||
               !this.cmp.isEqual(this.savedAppointment.signatures, newData.signatures) ||
               !this.cmp.isEqual(this.savedAppointment.answers, newData.answers) ||
               !this.cmp.isEqual(this.savedAppointment.apptIRSInfo, newData.irsInfo)) {
               this.dirty.personal = true
            }
            this.a.appointment.personal = newData.personal
            this.a.appointment.addresses = newData.addresses
            this.a.appointment.signatures = newData.signatures
            this.a.appointment.answers = newData.answers
            this.a.appointment.apptIRSInfo = newData.irsInfo
            this.a.appointment.qnaComment = newData.comments
            this.homeAddress = this.addressByType('ADRTYP_HOME')
            this.bizAddress = this.addressByType('ADRTYP_BUSINESS')

            this.PropogateSignature()

            this.calcCompletionPct()
         }
      }
   }
</script>

<style scoped lang="scss">
   @import "../assets/css/colors.scss";
   @import "../assets/css/validation.scss";

   body {
      background-color: #fff !important;
   }

   .appoint-page {
      margin-top: 154px;
      padding-top: 12px;
      padding-bottom: 36px;
      background-color: #fff;
   }

   .middle-column {
      padding: 12px;
   }

   .card-body {
      font-size: smaller;
   }

   .plinks {
      padding-right: 30px;
      transition: 0.3s ease-in-out;
      cursor: pointer;
   }

   .wf-buttons button {
      width: 100px;
      margin-right: 12px;
   }

   .submit-btn {
      border-color: $corp-color;
   }

   .plinks {
      list-style: none;
      margin: 0;
      padding: 0;
      width: 100%;
   }

   .plinks li {
      margin: 0;
      padding: 0;
      width: 100%;
   }

   .plinks li i {
      margin-right: 4px;
   }

   .plinks a {
      color: #000;
      border-bottom: 1px solid $corp-color;
      padding: 12px 12px 8px 12px;
      line-height: 20px;
      font-family: corporate-s, sans-serif;
      font-size: 16px;
      font-weight: 400;
      display: block;
      position: relative;
   }

   .plinks a:hover {
      text-decoration: none;
      background-color: $corp-menuhov;
   }

   .info-box {
      position: relative;
      font-size: 0.75em;
      width: 100%;
   }

   .p-chk {
      margin-left: 4px;
      color: $corp-color;
      font-size: smaller;
   }

   #bar-move {
      width: 100%;
      position: sticky;
   }

   #bar-move.grow-bar {
      transition: 0.3s ease-in-out;
      top: 166px;
   }

   #bar-move.shrink-bar {
      transition: 0.3s ease-in-out;
      top: 76px;
   }

   .deficient h3 {
      color: #990000;
   }

   .deficient-box {
      width: 100%;
      min-height: 300px;
      height: 300px;
      overflow-x: hide;
      overflow-y: scroll;
      color: #990000;
   }

   .error--row {
      border-bottom: 1px solid #000;
      font-size: smaller;
      padding: 4px;
      cursor: pointer;
   }

   .snc-btn {
      width: 180px;
   }
</style>

<!-- Apply to all child components as well -->
<style lang="scss">
   @import '../assets/css/colors.scss';
</style>